// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/unmappedAccounts/UnmappedAccountsPanel.scss
// module id = 2250
// module chunks = 0